import { useEffect } from 'react';
import { applyAppearance } from '../../lib/appearance';
import { useAppearanceStore } from '../../store/appearanceStore';
import { useTheme } from '../../store/themeStore';

/** Applies persisted appearance tokens whenever settings or light/dark theme changes. */
export function AppearanceSync() {
  const settings = useAppearanceStore((s) => s.settings);
  const { theme } = useTheme();

  useEffect(() => {
    applyAppearance(settings, theme);
  }, [settings, theme]);

  return null;
}
